import { render } from "./ShortcutBundlesTab.vue?vue&type=template&id=6f8b30a7&scoped=true"
import script from "./ShortcutBundlesTab.vue?vue&type=script&lang=js"
export * from "./ShortcutBundlesTab.vue?vue&type=script&lang=js"

import "./ShortcutBundlesTab.vue?vue&type=style&index=0&id=6f8b30a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8b30a7"]])

export default __exports__